import { createTheme } from '@aws-amplify/ui-react';

// Amplify UI очікує 7-ступеневу кольорову шкалу (10 — найсвітліший, 100 —
// найтемніший). Кнопки/посилання за замовчуванням беруть .80 як основний
// колір, .90 — hover, .100 — focus/active. Значення підібрані навколо
// бренд-зеленого (theme/colors.ts), а не точний HSL-алгоритм Amplify.
export const amplifyTheme = createTheme({
  name: 'svitlofour-admin-theme',
  tokens: {
    colors: {
      brand: {
        primary: {
          10: { value: '#E6F7EE' },
          20: { value: '#B3E8CC' },
          40: { value: '#4DD08F' },
          60: { value: '#00C25E' },
          80: { value: '#00B253' },
          90: { value: '#009E4A' },
          100: { value: '#00853E' },
        },
      },
    },
    radii: {
      small: { value: '6px' },
      medium: { value: '10px' },
      large: { value: '14px' },
    },
    fonts: {
      default: {
        variable: {
          value: 'Satoshi, -apple-system, BlinkMacSystemFont, sans-serif',
        },
        static: {
          value: 'Satoshi, -apple-system, BlinkMacSystemFont, sans-serif',
        },
      },
    },
  },
});
